import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './login.css';
import { useAuth } from '../../hooks/useAuth';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  
  const { login, loginLoading, loginError, isLoggedIn } = useAuth();


  useEffect(() => {
    if (isLoggedIn) {
      navigate('/Dashboard');
    }
  }, [isLoggedIn, navigate]);

  const validateForm = () => {
    const newErrors = {};


    if (!email.trim()) {
      newErrors.email = 'البريد الإلكتروني مطلوب';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'يرجى إدخال بريد إلكتروني صحيح';
    }


    if (!password.trim()) {
      newErrors.password = 'كلمة المرور مطلوبة';
    } else if (password.length < 6) {
      newErrors.password = 'كلمة المرور يجب أن تكون 6 أحرف على الأقل';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setErrors({});

    login({ email, password });
  };

  const clearError = (field) => {
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };


  const getErrorMessage = () => {
    if (loginError) {
      return loginError.message || 'فشل في تسجيل الدخول. يرجى المحاولة مرة أخرى.';
    }
    return null;
  };

  return (
    <div className="page-wrapper">
      <div className="container-login" id="container" dir="rtl">
        <div className="form-container-login sign-in-container-login">
          <form onSubmit={handleSubmit}>
            <h1>تسجيل الدخول</h1>
            
        
            {getErrorMessage() && (
              <div className="error-message submit-error">
                {getErrorMessage()}
              </div>
            )}
            
            <div className="infield-login">
              <input 
                type="email" 
                placeholder="البريد الإلكتروني" 
                name="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  clearError('email');
                }}
                className={errors.email ? 'error' : ''}
                disabled={loginLoading}
              />
              {errors.email && (
                <span className="error-message">{errors.email}</span>
              )}
            </div>
            
            <div className="infield-login">
              <input 
                type="password" 
                placeholder="كلمة المرور"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  clearError('password');
                }}
                className={errors.password ? 'error' : ''}
                disabled={loginLoading}
              />
              {errors.password && (
                <span className="error-message">{errors.password}</span>
              )}
            </div>
            
            <a href="#" className="forgot">هل نسيت كلمة المرور؟</a>
            
            <button 
              type="submit"
              className={`button-login ${loginLoading ? 'loading' : ''}`}
              disabled={loginLoading}
            >
              {loginLoading ? 'جاري تسجيل الدخول...' : 'دخول'}
            </button>
          </form>
        </div>

        <div className="overlay-container-login">
          <div className="overlay-login">
            <div className="overlay-panel-login overlay-right-login">
              <h1>لوحة تحكم الدار العراقية</h1>
              <p>مرحبا بك في لوحة التحكم. يمكنك من هنا إدارة المستخدمين، ومراقبة الأنشطة، وتحديث الإعدادات بسهولة</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;